import { Text } from '@mantine/core';

const PageHeaderText = ({ title }: { title: string }) => {
  return (
    <Text size="20px" fw="600">
      {title}
    </Text>
  );
};

export default PageHeaderText;
